import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ServerConnectionService } from './server-connection.service';

import { CoreModule } from '../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class UrlQueryService {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private scs: ServerConnectionService,
	) {
	}

	load() {
		const url = new URL(window.location.href);
		return Object.fromEntries(url.searchParams);
	}

	save(query) {
		this.router.navigate([], {
			relativeTo: this.activatedRoute,
			queryParams: query,
			queryParamsHandling: 'merge',
		});
	}

	replaceParams(query) {
		const urlTree = this.router.createUrlTree([], {
			relativeTo: this.activatedRoute,
			queryParams: query,
			queryParamsHandling: 'merge',
		});
		this.location.replaceState(this.router.serializeUrl(urlTree));
	}
}
